const toNumber = (value) => {
  const number = Number(value || 0);
  return Number.isFinite(number) ? number : 0;
};

const consumedFromEntry = (entry) => Math.max(
  toNumber(entry.grondstofKg) - toNumber(entry.restantKg),
  0,
);

export function findOversubscribedRawBatches({
  rawMaterials = [],
  expeditie = [],
  entries = [],
  halffabRuns = [],
}) {
  const batchesById = new Map(
    expeditie
      .filter((batch) => batch?.id != null && batch.grondstof)
      .map((batch) => [String(batch.id), batch]),
  );
  const usageByBatchId = new Map();
  const addUsage = (batchId, kg) => {
    if (!batchesById.has(String(batchId))) return;
    usageByBatchId.set(
      String(batchId),
      (usageByBatchId.get(String(batchId)) || 0) + toNumber(kg),
    );
  };

  entries.forEach((entry) => {
    if (entry?.expeditieId) addUsage(entry.expeditieId, consumedFromEntry(entry));
  });
  halffabRuns.forEach((run) => {
    (run?.verbruik || []).forEach((ingredient) => {
      if (ingredient?.categorie === "Grondstof" && ingredient.expeditieId) {
        addUsage(ingredient.expeditieId, ingredient.kg);
      }
    });
  });

  const articleByName = new Map(
    rawMaterials
      .filter((item) => item?.naam)
      .map((item) => [item.naam, item.artikelnummer || ""]),
  );
  const groups = new Map();
  batchesById.forEach((batch, id) => {
    const tracecode = String(batch.eigenTracecode || batch.batchnr || "").trim();
    const groupKey = `${batch.grondstof}|${tracecode || `partij-${id}`}`;
    const group = groups.get(groupKey) || {
      artikelnummer: articleByName.get(batch.grondstof) || "",
      naam: batch.grondstof,
      tracecode,
      datum: batch.datum || "",
      ontvangen: 0,
      verbruikt: 0,
      ids: [],
    };
    group.ontvangen += toNumber(batch.kg);
    group.verbruikt += usageByBatchId.get(id) || 0;
    group.ids.push(id);
    if (!group.datum || String(batch.datum || "") < String(group.datum)) {
      group.datum = batch.datum || "";
    }
    groups.set(groupKey, group);
  });

  return [...groups.values()]
    .map((group) => ({
      ...group,
      tekort: group.verbruikt - group.ontvangen,
    }))
    .filter((group) => group.tekort > 0.001)
    .sort((a, b) => b.tekort - a.tekort);
}